import { Platform, ViewStyle } from "react-native";

import { ClassGroupType } from "../../Style.types";

export interface IShadowClassGroup {
  shadowMain: ViewStyle;
  shadowDarker: ViewStyle;
  shadowLighter: ViewStyle;
}
export const ShadowClassGroup: ClassGroupType<IShadowClassGroup> = {
  shadowMain: {
    ...Platform.select({
      ios: {
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 2,
        },
        shadowOpacity: 0.23,
        shadowRadius: 2.62,
      },
      android: {
        elevation: 4,
      },
      web: {
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      },
    }),
  },
  shadowLighter: {
    ...Platform.select({
      ios: {
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 1,
        },
        shadowOpacity: 0.18,
        shadowRadius: 1.0,
      },
      android: {
        elevation: 1,
      },
      web: {
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)",
      },
    }),
  },
  shadowDarker: {
    ...Platform.select({
      ios: {
        shadowColor: "#000",
        shadowOffset: {
          width: 0,
          height: 3,
        },
        shadowOpacity: 0.27,
        shadowRadius: 4.65,
      },
      android: {
        elevation: 6,
      },
      web: {
        boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.25)",
      },
    }),
  },
};
